"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const cartbrand03 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 71 70",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-cartbrand03` : '') + (description ? ` desc-cartbrand03` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-cartbrand03"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-cartbrand03"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("g", {
    fill: "#FFB499",
    fillOpacity: ".5"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.63 19.107h52.602c.88 0 1.709.41 2.243 1.11.534.701.712 1.61.48 2.46l-5.794 21.28a8.47 8.47 0 0 1-8.167 6.251H21.167M21.537 65.759A4.237 4.237 0 0 0 25.77 70a4.237 4.237 0 0 0 4.234-4.241 4.237 4.237 0 0 0-4.234-4.241 4.237 4.237 0 0 0-4.233 4.24ZM49.76 65.759A4.237 4.237 0 0 0 53.992 70a4.237 4.237 0 0 0 4.233-4.241 4.243 4.243 0 0 0-2.117-3.673 4.227 4.227 0 0 0-4.233 0 4.243 4.243 0 0 0-2.117 3.673Z"
  })), /*#__PURE__*/_react.default.createElement("g", {
    fill: "#F04C24"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.616 15.137a1 1 0 0 1 1-1h52.602a3.82 3.82 0 0 1 3.038 1.504c.723.948.963 2.18.65 3.33l-5.794 21.278a9.47 9.47 0 0 1-9.133 6.99H16.153a1 1 0 1 1 0-2h34.826a7.47 7.47 0 0 0 7.203-5.515l5.794-21.279c.15-.55.035-1.138-.31-1.59a1.82 1.82 0 0 0-1.448-.718H9.616a1 1 0 0 1-1-1Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 1a1 1 0 0 1 1-1h1.067a6.647 6.647 0 0 1 6.502 5.284l9.4 44.741a4.647 4.647 0 0 0 4.545 3.696h32.109a1 1 0 0 1 0 2H22.514a6.647 6.647 0 0 1-6.502-5.285l.979-.205-.979.205-9.4-44.74A4.647 4.647 0 0 0 2.066 2H1a1 1 0 0 1-1-1ZM15.522 61.789a5.237 5.237 0 0 1 5.234-5.241 5.237 5.237 0 0 1 5.233 5.24 5.237 5.237 0 0 1-5.233 5.242 5.237 5.237 0 0 1-5.234-5.241Zm5.234-3.241a3.237 3.237 0 0 0-3.234 3.24 3.237 3.237 0 0 0 3.234 3.242 3.237 3.237 0 0 0 3.233-3.241 3.237 3.237 0 0 0-3.233-3.241ZM46.36 57.25a5.227 5.227 0 0 1 5.236 0 5.243 5.243 0 0 1 2.616 4.539 5.237 5.237 0 0 1-5.234 5.241 5.237 5.237 0 0 1-5.233-5.241c0-1.872.997-3.602 2.616-4.539Zm4.234 1.732a3.227 3.227 0 0 0-3.232 0 3.242 3.242 0 0 0-1.617 2.807 3.237 3.237 0 0 0 3.233 3.241 3.237 3.237 0 0 0 3.234-3.241 3.242 3.242 0 0 0-1.618-2.807Z"
  }))));
};
var _default = exports.default = cartbrand03;